import { MetricTypes } from '@spotify-internal/semantic-metrics';
import { defaultTags, MetricActions, sendMetric } from './utils/metricsHelper';
import getOAuthServerMetadata from './config/getOAuthServerMetadata';
const interactiveLogout = (authServerConfig, redirectUri) => {
    sendMetric({
        metric_type: MetricTypes.COUNTER,
        what: MetricActions.INTERACTIVE_LOGOUT,
        value: 1,
        tags: Object.assign({ serverUrl: authServerConfig.url }, defaultTags),
    });
    const { issuer } = getOAuthServerMetadata(authServerConfig);
    const continueUrl = redirectUri || window.location.href;
    window.location.href = `${issuer}/logout?continue=${encodeURIComponent(continueUrl)}`;
};
export { interactiveLogout };
//# sourceMappingURL=logout.js.map